/* src/app/shared/components/modals/projects/project-create-modal/project-create-configuracao/project-create-configuracao.component.scss */
.content {
  height: 100%;
}
.footer-height {
  height: 8%;
}
.title {
  text-align: left;
  font: normal normal normal 32px/39px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #007ACE;
  opacity: 1;
}
.subtitle {
  text-align: left;
  font: normal normal normal 16px/23px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
}
.body-content .mat-mdc-form-field {
  width: 100%;
}
.mat-form-field-label {
  border: 0px;
}
#no-file-box {
  height: 156px;
  width: 100%;
  background: #EEEEEE;
}
#no-file-box .icon {
  font-size: 65px;
  color: #D4D5D7;
}
#no-file-box img {
  width: 100%;
  object-fit: contain;
  height: 156px;
}
#title {
  letter-spacing: 0;
  color: #707070;
  font-size: 24px;
  font-weight: 400px;
}
.icon-txt {
  font-size: 16px;
  font-weight: 400px;
  color: #707070;
}
#upload-icon {
  color: #B4B4B8;
}
.upload-btn {
  background: #007AC2;
  border-radius: 27px;
  padding: 10px 50px;
  color: #ffffff;
}
.divEditor {
  width: 100%;
}
/*# sourceMappingURL=project-create-configuracao.component.css.map */
